export function getApiBase() {
  if (window && window.injectConfig && window.injectConfig.api) {
    return window.injectConfig.api;
  }
  return process.env.VUE_APP_BASE_API;
}

export function getsocketUrl() {
  return process.env.VUE_APP_WEBSOCKET_URL;
}
export function getImgUrl() {
  return process.env.VUE_APP_IMAGE_URL;
}